import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './Icon.module.css';

class Icon extends PureComponent {
  render() {
    const { iconName, fontSize, color } = this.props;

    return (
      <i className={`fl-${iconName}`} style={{ fontSize }} styleName={color} />
    );
  }
}

Icon.defaultProps = {
  fontSize: '1rem',
  color: 'black'
};

Icon.propTypes = {
  iconName: PropTypes.string.isRequired,
  fontSize: PropTypes.string,
  color: PropTypes.string
};

export default Icon;
